(function(){
  if (window.hhInit) return; window.hhInit = true;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var FREE = 6000;
  function money(c){ return '$' + (c/100).toFixed(2); }
  function esc(s){ var d=document.createElement('div'); d.textContent=s; return d.innerHTML; }
  var drawer = document.getElementById('hh-cart');
  function open(){ drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden','false'); document.documentElement.style.overflow='hidden'; }
  function close(){ drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden','true'); document.documentElement.style.overflow=''; }
  function render(cart){
    document.querySelectorAll('[data-hh-coins]').forEach(function(el){ el.textContent = Math.floor(cart.total_price/20); });
    document.querySelectorAll('.hh-drawer .hh-perks').forEach(function(el){ el.hidden = cart.item_count === 0; });
    document.querySelectorAll('[data-hh-count]').forEach(function(el){ el.textContent=cart.item_count; el.setAttribute('data-count',cart.item_count); });
    var left = FREE - cart.total_price;
    drawer.querySelector('[data-hh-ship]').innerHTML = (left > 0 ? 'You are ' + money(left) + ' away from free US shipping' : 'You get free US shipping') + '<div class="hh-drawer__bar"><span style="width:' + Math.min(100, Math.round(cart.total_price/FREE*100)) + '%"></span></div>';
    var box = drawer.querySelector('[data-hh-items]');
    if (!cart.items.length){ box.innerHTML = '<p class="hh-empty">Your bag is empty.<br><a class="hh-link" href="/collections/kits">Shop kits</a></p>'; }
    else box.innerHTML = cart.items.map(function(it){
      var img = it.image ? it.image + (it.image.indexOf('?')>-1?'&':'?') + 'width=200' : '';
      return '<div class="hh-line">'+(img?'<img src="'+img+'" alt="" loading="lazy">':'<span class="hh-line__ph" aria-hidden="true"></span>')+'<div class="hh-line__info"><b>'+esc(it.product_title)+'</b>'+(it.vendor?'<span class="hh-card__meta">'+esc(it.vendor)+'</span>':'')+'<div style="display:flex;justify-content:space-between;align-items:center;margin-top:4px;"><span class="hh-qty"><button type="button" aria-label="Less" data-hh-qty="'+it.key+'" data-q="'+(it.quantity-1)+'">&minus;</button><span>'+it.quantity+'</span><button type="button" aria-label="More" data-hh-qty="'+it.key+'" data-q="'+(it.quantity+1)+'">+</button></span><b>'+money(it.final_line_price)+'</b></div></div></div>';
    }).join('');
    drawer.querySelector('[data-hh-subtotal]').textContent = money(cart.total_price);
    recs(cart);
    try { document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart })); } catch(e){}
  }
  /* "goes well with" picks in the bag, based on the last item added */
  var recBox = drawer.querySelector('[data-hh-cart-recs]'), recFor = null;
  function recs(cart){
    if (!recBox) return;
    if (!cart.items.length){ recBox.innerHTML=''; recFor=null; return; }
    var pid = cart.items[0].product_id; var inCart = cart.items.map(function(i){ return i.product_id; });
    var key = pid + ':' + inCart.join(','); if (key === recFor) return; recFor = key;
    var none = function(){ return []; };
    var api = function(intent){ return fetch(root+'recommendations/products.json?product_id='+pid+'&limit=8&intent='+intent).then(function(r){ return r.ok ? r.json() : {products:[]}; }).then(function(j){ return (j.products || []).map(function(p){
      var v = p.variants.filter(function(x){ return x.available; })[0] || p.variants[0];
      return {id:p.id, title:p.title, url:p.url, img:p.featured_image, vid:v.id, price:v.price, ok:p.available};
    }); }).catch(none); };
    /* same-concern picks first: read the item's concern tag, then pull that concern collection */
    var MAP = [['dark-spots','dark-spots'],['dry-skin','dry-and-sensitive-skin'],['oily-skin','oily-and-acne-prone-skin'],['dull-skin','dull-skin'],['under-eye','under-eye-care'],['curly-hair','curly-and-frizzy-hair'],['scalp','scalp-and-hair-fall'],['lips','lip-care'],['makeup','makeup'],['body','body'],['period-care','period-care'],['hair','hair'],['skin','skin']];
    var concern = fetch(root+'products/'+cart.items[0].handle+'.js').then(function(r){ return r.json(); }).then(function(p){
      var c = null; MAP.some(function(m){ if (p.tags.indexOf(m[0]) > -1){ c = m[1]; return true; } return false; });
      if (!c) return [];
      return fetch(root+'collections/'+c+'/products.json?limit=16').then(function(r){ return r.json(); }).then(function(j){ return (j.products || []).map(function(x){
        var v = x.variants.filter(function(y){ return y.available; })[0] || x.variants[0];
        return {id:x.id, title:x.title, url:root+'products/'+x.handle, img:x.images && x.images[0] ? x.images[0].src : '', vid:v.id, price:Math.round(parseFloat(v.price)*100), ok:x.variants.some(function(y){ return y.available; })};
      }); });
    }).catch(none);
    Promise.all([concern, api('complementary'), api('related')]).then(function(res){
      var seen = {}; var list = res[0].concat(res[1], res[2]).filter(function(p){ if (seen[p.id] || inCart.indexOf(p.id) > -1 || !p.ok) return false; seen[p.id]=1; return true; }).slice(0,3);
      if (!list.length){ recBox.innerHTML=''; return; }
      recBox.innerHTML = '<b class="hh-recs__h">Goes well with this</b>' + list.map(function(p){
        var img = p.img ? p.img + (p.img.indexOf('?')>-1?'&':'?') + 'width=160' : '';
        return '<div class="hh-rec"><a href="'+p.url+'">'+(img?'<img src="'+img+'" alt="" loading="lazy">':'<span class="hh-rec__ph"></span>')+'</a><div class="hh-rec__info"><a href="'+p.url+'"><b>'+esc(p.title)+'</b></a><span>'+money(p.price)+'</span></div><button type="button" class="hh-rec__add" data-hh-rec-add="'+p.vid+'">Add</button></div>';
      }).join('');
    });
  }
  function refresh(){ return fetch(root+'cart.js',{headers:{Accept:'application/json'}}).then(function(r){return r.json();}).then(render); }
  document.addEventListener('click', function(e){
    var o = e.target.closest('[data-hh-open-cart]'); if (o){ e.preventDefault(); refresh().then(open); return; }
    if (e.target.closest('[data-hh-close-cart]')){ close(); return; }
    var ra = e.target.closest('[data-hh-rec-add]');
    if (ra){ ra.disabled = true; ra.textContent = 'Adding'; fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:Number(ra.getAttribute('data-hh-rec-add')),quantity:1}]})}).then(function(){ return refresh(); }).catch(function(){ ra.disabled=false; ra.textContent='Add'; }); return; }
    var q = e.target.closest('[data-hh-qty]');
    if (q){ fetch(root+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:q.getAttribute('data-hh-qty'),quantity:Number(q.getAttribute('data-q'))})}).then(function(r){return r.json();}).then(render); return; }
    var b = e.target.closest('[data-hh-burger]');
    if (b){ var nav=document.getElementById('hh-nav'); var on=b.getAttribute('aria-expanded')==='true'; b.setAttribute('aria-expanded', on?'false':'true'); nav.classList.toggle('is-open',!on); return; }
    var t = e.target.closest('[data-hh-tabs] [role="tab"]');
    if (t){ var wrap=t.closest('[data-hh-tabs]'); wrap.querySelectorAll('[role="tab"]').forEach(function(x){ var on=x===t; x.setAttribute('aria-selected',on?'true':'false'); x.tabIndex=on?0:-1; var p=document.getElementById(x.getAttribute('aria-controls')); if(p)p.hidden=!on; }); var n=wrap.querySelector('[data-hh-tabnote]'); if(n)n.textContent=t.getAttribute('data-note')||''; }
  });
  document.addEventListener('keydown', function(e){ if (e.key==='Escape' && drawer.classList.contains('is-open')) close(); });
  document.addEventListener('submit', function(e){
    var f = e.target.closest('[data-hh-quickadd]'); if (!f) return;
    e.preventDefault();
    var btn=f.querySelector('button'); if(btn) btn.disabled=true;
    fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:Number(f.querySelector('[name=id]').value),quantity:1}]})})
      .then(function(r){return r.json();}).then(function(){ return refresh(); }).then(open)
      .catch(function(){ f.submit(); }).finally(function(){ if(btn) btn.disabled=false; });
  });
})();

/* come-back offer: buyer left checkout and came back with items in the bag */
(function(){
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var KEY = 'hh_co', SEEN = 'hh_cb_seen', WINDOW = 3 * 60 * 60 * 1000;
  function get(s, k){ try { return s.getItem(k); } catch(e){ return null; } }
  function set(s, k, v){ try { s.setItem(k, v); } catch(e){} }
  function del(s, k){ try { s.removeItem(k); } catch(e){} }
  function mark(){ set(localStorage, KEY, String(Date.now())); }
  document.addEventListener('submit', function(e){
    var b = e.submitter; if (b && b.name === 'checkout') mark();
  }, true);
  document.addEventListener('click', function(e){
    var a = e.target.closest('a[href*="/checkout"],button[name="checkout"],[data-hh-checkout]'); if (a) mark();
  }, true);
  var box = document.querySelector('[data-hh-cb]'); if (!box) return;
  function money(c){ return '$' + (c/100).toFixed(2); }
  var last = null;
  function close(){ box.hidden = true; document.documentElement.style.overflow = ''; if (last) last.focus(); }
  function show(cart){
    var pct = Number(box.getAttribute('data-pct')) || 10;
    var save = Math.round(cart.total_price * pct / 100);
    box.querySelectorAll('[data-hh-cb-save]').forEach(function(el){ el.textContent = money(save); });
    var coins = Math.floor(cart.total_price / 20);
    box.querySelector('[data-hh-cb-coins]').textContent = coins + (coins === 1 ? ' coin' : ' coins');
    last = document.activeElement;
    box.hidden = false; document.documentElement.style.overflow = 'hidden';
    var go = box.querySelector('[data-hh-cb-go]'); if (go) go.focus();
    set(sessionStorage, SEEN, '1');
  }
  function check(){
    var t = Number(get(localStorage, KEY)); if (!t) return;
    if (Date.now() - t > WINDOW) { del(localStorage, KEY); return; }
    if (get(sessionStorage, SEEN)) return;
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function(r){ return r.json(); }).then(function(cart){
      del(localStorage, KEY);
      if (cart.item_count > 0) show(cart);
    }).catch(function(){});
  }
  box.addEventListener('click', function(e){
    if (e.target.closest('[data-hh-cb-close]')) close();
    if (e.target.closest('[data-hh-cb-go]')) del(localStorage, KEY);
  });
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && !box.hidden) close(); });
  window.addEventListener('pageshow', check);
})();

/* homepage reels: play in place */
document.addEventListener('click', function(e){
  var b = e.target.closest('[data-hh-yt]'); if (!b) return;
  e.preventDefault();
  var f = document.createElement('iframe');
  f.src = 'https://www.youtube-nocookie.com/embed/' + b.getAttribute('data-hh-yt') + '?autoplay=1&playsinline=1&rel=0&enablejsapi=1';
  f.title = b.getAttribute('aria-label') || 'Video';
  f.allow = 'autoplay; encrypted-media; picture-in-picture'; f.allowFullscreen = true;
  f.className = 'hh-vid__frame';
  b.replaceWith(f);
});

/* rails: arrows on desktop, and only one homepage video plays at a time */
(function(){
  function setup(r){
    if (r.getAttribute('data-hh-arrows')) return; r.setAttribute('data-hh-arrows','1');
    var w = document.createElement('div'); w.className = 'hh-railwrap'; r.parentNode.insertBefore(w, r); w.appendChild(r);
    ['prev','next'].forEach(function(d){
      var b = document.createElement('button'); b.type = 'button'; b.className = 'hh-railbtn hh-railbtn--' + d;
      b.setAttribute('aria-label', d === 'prev' ? 'Previous' : 'Next'); b.innerHTML = d === 'prev' ? '&#8249;' : '&#8250;';
      b.addEventListener('click', function(){ r.scrollBy({ left: (d === 'prev' ? -1 : 1) * r.clientWidth * 0.85, behavior: 'smooth' }); });
      w.appendChild(b);
    });
    function upd(){ w.classList.toggle('is-start', r.scrollLeft < 5); w.classList.toggle('is-end', r.scrollLeft + r.clientWidth >= r.scrollWidth - 5); w.classList.toggle('no-scroll', r.scrollWidth <= r.clientWidth + 5); }
    r.addEventListener('scroll', upd, { passive: true }); window.addEventListener('resize', upd); window.addEventListener('load', upd); upd();
  }
  function all(){ document.querySelectorAll('.hh-rail').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('play', function(e){ document.querySelectorAll('video').forEach(function(v){ if (v !== e.target) v.pause(); }); }, true);
  document.addEventListener('click', function(e){
    if (!e.target.closest('[data-hh-yt]')) return;
    document.querySelectorAll('.hh-vid__frame').forEach(function(f){ f.src = f.src.replace('autoplay=1', 'autoplay=0'); });
    document.querySelectorAll('video').forEach(function(v){ v.pause(); });
  }, true);
})();


/* clear sound on/off button on every video we control */
(function(){
  var ON='<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 9v6h4l5 4V5L8 9H4z" fill="currentColor"/><path d="M16 8.5a5 5 0 0 1 0 7M18.5 6a8.5 8.5 0 0 1 0 12" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round"/></svg>';
  var OFF='<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 9v6h4l5 4V5L8 9H4z" fill="currentColor"/><path d="M16.5 9.5l5 5M21.5 9.5l-5 5" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
  function yt(f,fn){try{f.contentWindow.postMessage(JSON.stringify({event:'command',func:fn,args:[]}),'*')}catch(e){}}
  function make(host,get,flip){
    var b=document.createElement('button');b.type='button';b.className='hh-snd';
    function draw(){var m=get();b.innerHTML=(m?OFF:ON)+'<span>'+(m?'Sound off':'Sound on')+'</span>';b.setAttribute('aria-label',m?'Turn sound on':'Turn sound off');b.classList.toggle('is-off',m)}
    b.addEventListener('click',function(e){e.preventDefault();e.stopPropagation();flip();draw()});
    host.appendChild(b);draw();return draw;
  }
  function wireVideo(v){
    if(v.__snd)return;v.__snd=1;
    var host=v.closest('.hh-hx__slide')||v.parentElement;
    if(getComputedStyle(host).position==='static')host.style.position='relative';
    var draw=make(host,function(){return v.muted},function(){v.muted=!v.muted;if(!v.muted){if(v.volume===0)v.volume=1;if(v.paused)v.play().catch(function(){})}});
    v.addEventListener('volumechange',draw);
  }
  function wireYt(f){
    if(f.__snd)return;f.__snd=1;
    var m=false,host=f.parentElement;
    if(getComputedStyle(host).position==='static')host.style.position='relative';
    host.classList.add('hh-snd-host--yt');
    f.addEventListener('load',function(){setTimeout(function(){yt(f,'unMute');yt(f,'setVolume')},600)});
    make(host,function(){return m},function(){m=!m;yt(f,m?'mute':'unMute')});
  }
  function scan(root){
    (root||document).querySelectorAll('video').forEach(wireVideo);
    (root||document).querySelectorAll('iframe[src*="youtube"]').forEach(function(f){if(f.src.indexOf('enablejsapi=1')>-1)wireYt(f)});
  }
  function start(){scan();new MutationObserver(function(ms){ms.forEach(function(x){x.addedNodes.forEach(function(n){if(n.nodeType!==1)return;if(n.matches&&(n.matches('video')||n.matches('iframe')))scan(n.parentElement);else if(n.querySelector&&n.querySelector('video,iframe'))scan(n)})})}).observe(document.body,{childList:true,subtree:true})}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();
})();


/* Instagram reels: load the ones in view (a few at a time), tap loads any other */
(function(){
  function url(b){var u=(b.getAttribute('data-hh-ig')||'').split('?')[0];if(u&&u.slice(-1)!=='/')u+='/';return u}
  function mount(b){
    if(b.__m)return;b.__m=1;var u=url(b);if(!u)return;
    var f=document.createElement('iframe');
    f.className='hh-ig';f.src=u+'embed/';f.title='Clip on Instagram';f.setAttribute('scrolling','no');
    f.setAttribute('allow','autoplay; encrypted-media; clipboard-write');f.setAttribute('allowtransparency','true');
    b.appendChild(f);
  }
  function prep(b){
    var ph=b.querySelector('.hh-reel__ph');
    if(ph){ph.innerHTML='<span class="hh-reel__play" aria-hidden="true"></span><span>Tap to play</span>';
      ph.addEventListener('click',function(e){if(!b.__m){e.preventDefault();mount(b)}})}
  }
  function check(){
    var H=window.innerHeight||800;
    document.querySelectorAll('.hh-rail').forEach(function(r){
      var rr=r.getBoundingClientRect();if(rr.bottom<-H||rr.top>H*1.5)return;
      r.querySelectorAll('[data-hh-ig]').forEach(function(b){
        if(b.__m)return;var cr=b.getBoundingClientRect();
        if(cr.right>rr.left-40&&cr.left<rr.right+rr.width*0.6)mount(b);
      });
    });
  }
  var q=0;function soon(){if(q)return;q=setTimeout(function(){q=0;check()},150)}
  function start(){
    document.querySelectorAll('[data-hh-ig]').forEach(prep);
    check();
    window.addEventListener('scroll',soon,{passive:true});window.addEventListener('resize',soon);
    document.querySelectorAll('.hh-rail').forEach(function(r){r.addEventListener('scroll',soon,{passive:true})});
    setTimeout(check,1200);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();
})();

/* v3: mix the video rail so one product's clips are not all in a row */
(function(){
  function mix(){
    document.querySelectorAll('.hh-rail').forEach(function(r){
      if(r.dataset.mixed) return;
      var cards=[].filter.call(r.children,function(c){return c.classList.contains('hh-vidcard')});
      if(cards.length<4) return;
      var g={},order=[];
      cards.forEach(function(c,i){var a=c.querySelector('.hh-vidcard__p');var k=a?a.getAttribute('href'):'x'+i;if(!g[k]){g[k]=[];order.push(k)}g[k].push(c)});
      var out=[],more=true;
      while(more){more=false;order.forEach(function(k){if(g[k].length){out.push(g[k].shift());more=true}})}
      out.forEach(function(c){r.appendChild(c)});
      r.dataset.mixed='1';
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',mix); else mix();
})();
/* v7 creator clips: one plays at a time, posters load near the viewport */
(function(){
  if (window.hhClipInit) return; window.hhClipInit = true;
  document.addEventListener('play', function(e){
    var t = e.target; if (!t || t.tagName !== 'VIDEO') return;
    document.querySelectorAll('video').forEach(function(v){ if (v !== t && !v.paused && !v.muted) v.pause(); });
  }, true);
  function hhcArm(){
    var queued = false;
    function chk(){
      queued = false; var W = window.innerWidth, H = window.innerHeight;
      document.querySelectorAll('video[data-poster]').forEach(function(v){
        var b = v.getBoundingClientRect(); if (!b.width) return;
        if (b.bottom > -H && b.top < H * 2 && b.right > -W && b.left < W * 2) { v.poster = v.dataset.poster; v.removeAttribute('data-poster'); }
      });
    }
    function qu(){ if (!queued) { queued = true; setTimeout(chk, 80); } }
    document.addEventListener('scroll', qu, { capture: true, passive: true });
    window.addEventListener('resize', qu);
    chk(); setTimeout(chk, 600); setTimeout(chk, 2000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', hhcArm); else hhcArm();
})();

/* hh chat tab: slide the chat button in and out on phones (31 Oct) */
(function(){
  var mq=window.matchMedia('(max-width:749px)'),K='hh_chat_off',root=document.documentElement;
  function get(){try{return localStorage.getItem(K)==='1'}catch(e){return false}}
  function set(v){try{localStorage.setItem(K,v?'1':'0')}catch(e){}}
  var tab=document.createElement('button');tab.type='button';tab.className='hh-chat-tab';tab.hidden=true;
  function paint(){var off=root.classList.contains('hh-chat-off');tab.innerHTML=off?'&#8249;':'&#8250;';tab.setAttribute('aria-label',off?'Show chat button':'Hide chat button');}
  tab.addEventListener('click',function(){var off=!root.classList.contains('hh-chat-off');root.classList.toggle('hh-chat-off',off);set(off);paint();});
  function locate(){
    var host=document.querySelector('shopify-chat');if(!host)return false;
    var W=window.innerWidth,H=window.innerHeight,minx=1e9,miny=1e9,maxy=-1;
    for(var y=H-280;y<H;y+=6){for(var x=W-240;x<W;x+=6){if(document.elementFromPoint(x,y)===host){if(x<minx)minx=x;if(y<miny)miny=y;if(y>maxy)maxy=y;}}}
    if(maxy<0)return false;
    var nav=0;document.querySelectorAll('body *').forEach(function(e){if(e===host||e===tab)return;var s=getComputedStyle(e);if(s.position!=='fixed'||s.display==='none'||s.visibility==='hidden')return;var r=e.getBoundingClientRect();if(r.width>=W*0.8&&r.bottom>=H-2&&r.top>H*0.6&&r.height<160&&r.height>nav)nav=r.height;});root.style.setProperty('--hh-chat-bottom',Math.max(Math.round(nav+10),Math.round(H-(miny+maxy)/2-22))+'px');
    root.style.setProperty('--hh-chat-shift',Math.round(W-minx+16)+'px');
    return true;
  }
  function init(n){
    if(!mq.matches){tab.hidden=true;root.classList.remove('hh-chat-off');return;}
    root.classList.remove('hh-chat-off');
    if(locate()){if(!tab.isConnected)document.body.appendChild(tab);tab.hidden=false;if(get())root.classList.add('hh-chat-off');paint();}
    else if(n<20){setTimeout(function(){init(n+1)},500);}
  }
  /* chat tab turned off 31 Oct: chat button is hidden on phones in hh.css */
})();

/* hh chat item in the phone app bar: opens Shopify chat (31 Oct) */
(function(){
  function add(){
    var bar=document.querySelector('.hh-appbar');if(!bar||bar.querySelector('.hh-appbar__chat'))return;
    var b=document.createElement('button');b.type='button';b.className='hh-appbar__chat';
    b.innerHTML='<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round" aria-hidden="true"><path d="M4 5h16v11H10l-6 4z"></path></svg>Chat';
    b.addEventListener('click',function(){var c=document.querySelector('shopify-chat');if(c){c.setAttribute('open','')}else{window.location.href='/pages/contact'}});
    var me=bar.querySelector('a[href="/account"]');bar.insertBefore(b,me||null);bar.classList.add('hh-appbar--chat');
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',add)}else{add()}
})();

/* hh chat on phones: keep the floating chat pill off screen while chat is closed (31 Oct) */
(function(){
  var mq=window.matchMedia('(max-width:749px)'),seen=null;
  function sync(){
    var c=document.querySelector('shopify-chat');if(!c)return false;
    if(c!==seen){seen=c;new MutationObserver(sync).observe(c,{attributes:true,attributeFilter:['open']});}
    var hide=mq.matches&&!c.hasAttribute('open');
    c.style.transform=hide?'translateX(150vw)':'';c.style.opacity=hide?'0':'';c.style.pointerEvents=hide?'none':'';
    return true;
  }
  var n=0;(function tick(){if(!sync()&&n++<40)setTimeout(tick,250)})();
  mq.addEventListener&&mq.addEventListener('change',sync);
})();

/* hh: no white gap above the footer when a page ends with a dark section */
(function(){function fix(){var ft=document.querySelector('footer.hh-footer'),m=document.querySelector('main');if(!ft||!m)return;var mb=m.getBoundingClientRect().bottom,el=m,bg=null;for(var i=0;i<12&&el;i++){var kids=[].filter.call(el.children,function(c){return c.getBoundingClientRect().height>0&&getComputedStyle(c).position!=='fixed'});var last=kids[kids.length-1];if(!last||Math.abs(last.getBoundingClientRect().bottom-mb)>2)break;var c=getComputedStyle(last).backgroundColor;if(c&&c!=='rgba(0, 0, 0, 0)'&&c!=='transparent'){bg=c;break}el=last}if(!bg)return;var n=bg.match(/[0-9.]+/g).map(Number);var l=(0.299*n[0]+0.587*n[1]+0.114*n[2])/255;if(l<0.35)ft.style.marginTop='0'}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',fix);else fix();window.addEventListener('load',fix)})();
